<div class="custom-dropdown">
  <div
    class="dropdown-header"
    [ngClass]="{
      primary: variant === 'primary',
      secondary: variant === 'secondary',
    }"
    (click)="toggleDropdown()"
    >
    {{
    selectedOption
    ? selectedOption.label
    : placeholder
    ? placeholder
    : "Select an option"
    }}
    @if (options?.length > 1) {
      <ng-content select="[icon]"></ng-content>
    }
  </div>
  @if (isDropdownOpen && options?.length>1) {
    <ul class="options-list">
      @for (option of options; track option) {
        <li
      [ngClass]="{
        selected: selectedOption && selectedOption.label == option.label
      }"
          (click)="selectOption(option)"
          >
          {{ option.label }}
        </li>
      }
    </ul>
  }
</div>
